module.exports = __webpack_public_path__ + "img/71_12.37117e80.png";